module.exports = __webpack_public_path__ + "static/img/wms.f5e08df8.svg";